import { useCallback } from "react";

export enum GtagEvents {
    ReelsModalOpen = "reels_modal_open",
    ReelsShare = "reels_share",
    ReelsModalPlay = "reels_modal_play",
    CpfSignupOpen = "cpf_open",
    CpfSignupSubmitCpf = "cpf_submit",
    CpfSignupSuccess = "cpf_success",
    CpfSignupSubmitError = "cpf_error",
    SignupSubmit = "reg_submit",
    SignupSuccess = "reg_success",
    SignupError = "reg_error",
    SignupOpen = "reg_open",
}

export type IHostGtagEventPayload =
    | {
          reels_title: string;
          reels_label: string;
      }
    | { cpf_error_message: string; cpf_error_num: string }
    | { signup_error_message: string };

export const useGtag = () => {
    const fireEvent = useCallback((name: GtagEvents, payload?: IHostGtagEventPayload) => {
        if (typeof window.gtag === "function") {
            window.gtag("event", name, payload);
        }
    }, []);

    return {
        fireEvent,
    };
};
